import React, {useState} from 'react'
import Title from '../title/Title'
import Input from '../input/Input'
import malak from '../../assets/svg/Group -25.svg'
import add from '../../assets/svg/Group -9.svg'
import abrar from '../../assets/svg/Group 92.svg'
import yazeed from '../../assets/svg/Group 91.svg'
import dina from '../../assets/svg/Group 90.svg'
import bar from '../../assets/png/Group -91.png'
import placeholder from '../../assets/png/Rectangle 94.png'
import PopUp from '../popUp/PopUp'
import PopImg from '../../assets/png/Group 73.png'
import User from '../../components/user/User'
import Check from '../check/Check'
import PageControls from '../PageControls/PageControls'
import img from '../../assets/png/Group -20.png'
import prurpes1 from '../../assets/png/purpes 1.png'
import prurpes2 from '../../assets/png/purpes 2.png'
import prurpes3 from '../../assets/png/purpes 3.png'
import prurpes4 from '../../assets/png/purpes 4.png'
import prurpes5 from '../../assets/png/purpes 5.png'
import prurpes6 from '../../assets/png/purpes 6.png'
import pressedIcon from '../../assets/svg/pressedIcon.svg'
import popUpImage1 from '../../assets/png/popup plan 1.png'
import popUpImage2 from '../../assets/png/popup plan 2.png'
import popUpImage3 from '../../assets/png/popup plan 3.png'



const users = [{name:'Malak' , img:malak }, {name:'Dina' , img:dina },{name:'Yazeed' , img:yazeed },{name:'Abrar' , img:abrar } ,{name:'Add' , img:add }, ]
const popUps = ['none', 'action', 'voting', 'breaks', 'nextPage']
const purposeButtons = [prurpes1,prurpes2,prurpes3, prurpes4,prurpes5,prurpes6 ]

export default function Brainstorming({nextPage}) {
    const [popUp , setPopUp] = useState('none')
    const handleCancel = () => { 
        setPopUp('none')
    }
    const nextPopUp = (add )=> { 
        let step = popUps[popUps.indexOf(popUp) + add]
        if(step == 'nextPage') nextPage(1)
        setPopUp(step) 

    }
    const [pressed, setPressed] = useState([])
    const togglePressed = (i) =>{ 
        if(pressed.indexOf(i) === -1){ 
            setPressed([...pressed, i])
        }else{ 
            let filtered = pressed.filter(d => d !== i)
            setPressed(filtered)
        }
    }
    const isPressed = (i) => pressed.indexOf(i) !== -1 

    const [button, setButton] = useState('')
    const clickButton = (name) => { 
        setButton(name === button? '':name)
    }
    return (
        <div className="brainstorming">
            <PageControls nextPage={nextPage} /> 
          <Title title="Brainstorming Session" subtitle={"Let’s get the spark flying, Schedule a session!"} /> 
          <div className="brainstormingActions">
<div className="section">

          <Input title="We are brainstorming:" placeholder="What is the goal?"/>
          <h4 className="actionTitle">
          Our purpose is:
          </h4>
          <div className="purpose">
            {purposeButtons.map((el, i)=><div onClick={() => togglePressed(i)} className={"purposeButtons hoverImage " + (isPressed(i)?'pressed':'')}>
            {isPressed(i)? <img src={pressedIcon} className="pressedIcon" alt=""/> :''}

                <img className={"pImage "+ (isPressed(i)?'pressed' :'')} src={el}/>
                </div>)}
          </div>
</div>
<div className="section">

          
          <Input title="Let’s choose a date & time:" placeholder="Date - day - hour - minute"/>

          <Input title="Who is attending?" placeholder="Type in team members name" search/>
            <div className="users">
                {users.map(el =><User el={el} /> )}
            </div>
            <h4 className="actionTitle">Our brainstorming location:</h4>
<div className="buttons">
    <button className={"outline " + (button == 'office'? 'pressed':'') } onClick={()=>clickButton('office')} >Office</button>
    <button className={"outline " + (button == 'online'? 'pressed':'') } onClick={()=>clickButton('online')} >Online</button>
</div>
<h4 className="actionTitle">Add a playlist:</h4>
<div className="playlist">
    <Check text="Play Habhab’s playlist" checked /> 
    <Check text="Add your a playlist" /> 
    <Input className="disabled"/>

</div>
      
</div>
<div className="section fixed">
<div className="bar">
                        <img src={bar} style={{opacity: 0}} alt="" />
                    </div>
<div className="buttons end">
            <button className="outline noPadding">Save as draft</button>
            <button className="next" onClick={() => nextPopUp(1)}>Next</button>
        </div>
</div>
<div className="section">
</div>
          
          </div>
          <PopUp
            appear={popUp === 'action'}
            nextPage={nextPopUp}
            handleCancel={handleCancel}
            img={popUpImage1}
            title="Let’s optimize your brainstorming!" 
            text={['Based on the attending team members! Your team will work better if you decide on an action plan !','Would you like to add planning structure to your brainstorming session?']}  
            buttons={[{text:'Maybe Later', color:'outlined'}, {text: "Sure!", color:"yellow"}]}/>
        <PopUp
            appear={popUp === 'voting'}
            nextPage={nextPopUp}
            handleCancel={handleCancel}
            img={popUpImage2}
            title="Great! Let’s make some decisions." 
            text={['Based on the attending team members! Your team will work better if you decide on an action plan !','Would you like to add planning structure to your brainstorming session?']}  
            buttons={[{text:'No! I’ll decide', color:'outlined'}, {text: "Oh! Yes", color:"pink"}]}/>
          
          <PopUp
            appear={popUp === 'breaks'}
            nextPage={nextPopUp}
            handleCancel={handleCancel}
            img={popUpImage3}
            title="Oh! You’ll need short energy Boost breaks!" 
            text={['Based on the attending team members! Your team will work better if you decide on an action plan !','Would you like to add planning structure to your brainstorming session?']}  
            buttons={[{text:'Maybe not', color:'outlined'}, {text: "Absolutely", color:"red"}]}/>
          
        </div>
    )
}
